import React, { Component } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { load } from 'react-cookies';
import api from '../../services/api';
import Modal from 'react-bootstrap/Modal';

import '../../assets/scss/usuario_grupo.scss';
import Loader from '../../components/loader';
import UsuarioGrupoItem from '../../components/usuario/usuario_grupo';
import IconButton from '../../components/util/IconButton';
import { faIdBadge, faPaperPlane, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import UsuarioGrupoModal from '../../components/usuario/usuario_grupo_modal';

export default class UsuarioGrupo extends Component {
    state = {
        administrador: false,
        usuarioGrupos: [],
        page: 1,
        searching: false,
        adicionar: false,
        grupos: null,
    }

    loadUsuarioGrupo = async(usuarioGrupo = null) => {
        try {
            if (!usuarioGrupo) {
                this.setState({ usuarioGrupos: [], baixar: [], searching: true })
    
                const usuarioGrupos = (await api.get(`/usuario_grupo?itens=all`)).data;
        
                this.setState({ usuarioGrupos, searching: false })
            } else {
                const { usuarioGrupos } = this.state;
                const excluir = typeof usuarioGrupo !== 'object';

                let alterou = usuarioGrupos.findIndex(item => {
                    return (excluir ? usuarioGrupo : usuarioGrupo.codigo) == item.codigo
                });
                if (alterou >= 0) {
                    delete usuarioGrupos[alterou];
                    setTimeout(() => {
                        if (excluir) {
                            usuarioGrupos.splice(alterou, 1)
                        } else {
                            usuarioGrupos[alterou] = usuarioGrupo;
                        }
                        this.setState({ usuarioGrupos });
                    }, 450)
                } else {
                    usuarioGrupos.push(usuarioGrupo);
                }
                this.setState({ usuarioGrupos });
            }
        } catch (error) {
            console.log(error);
        }
    }

    async componentDidMount() {
        const usuarioGrupo = load('CENTROPLAST_INTRANET_USUARIO');
        if (!usuarioGrupo.administrador) {
            return;
        }
        this.setState({ administrador: true })

        this.loadUsuarioGrupo();
    }

    renderUsuarioGrupos = () => {
        const { usuarioGrupos, grupos, searching } = this.state;

        if (usuarioGrupos.length > 0) {
            return (
                <TransitionGroup className="usuariogrupomain-grupos">
                    {usuarioGrupos.map((usuarioGrupo, index) => {
                        return (
                            <CSSTransition
                                key={index}
                                classNames="usuariogrupomain-grupos-transition"
                                timeout={500}>
                                <div className="usuariogrupomain-grupo">
                                    <div className="usuariogrupomain-grupo-container">
                                        <UsuarioGrupoItem
                                            grupos={grupos}
                                            loadUsuarioGrupo={this.loadUsuarioGrupo}
                                            usuarioGrupo={usuarioGrupo} />
                                    </div>
                                </div>
                            </CSSTransition>
                        )
                    })}
                </TransitionGroup>
            );
        }
        if (searching) {
            return (
                <div className="usuariogrupomain-loader">
                    <Loader />
                </div>
            )
        }
        return (
            <div>
                Sem grupos de usuário
            </div>
        )
    }

    render() {
        const { administrador, adicionar, grupos } = this.state;

        if (administrador) {
            return (<>
                <div className="usuariogrupomain-header">
                    <IconButton className="usuariogrupomain-header-btn" icon={faPlus} text="Adicionar" onClick={() => this.setState({ adicionar: true })} />
                    <IconButton className="usuariogrupomain-header-btn" icon={faPaperPlane} text="Enviar mensagem" link="/usuario/mensagem" />
                </div>
                {this.renderUsuarioGrupos()}
                <UsuarioGrupoModal
                    show={adicionar}
                    grupos={grupos}
                    onSuccess={this.loadUsuarioGrupo}
                    onHide={() => this.setState({ adicionar: false })} />
            </>);
        }
        const onHide = () => window.location.href = '/';
        return (
            <Modal dialogClassName='modal-md' show={true} onHide={onHide}>
                <Modal.Body className="usuariogrupo-modal-title">Você não tem permissão para acessar essa página</Modal.Body>
                <Modal.Footer className="usuariogrupo-modal-confirm-footer">
                    <IconButton text="Fechar" icon={faTimes} onClick={onHide} />
                </Modal.Footer>
            </Modal>
        );
    }
}